import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {toInt} from '../library/math';
import {POLL_RANGE_NO_EXPIRED} from '../library/modules/poll';

const PollList  = () => import('../views/poll/PollList.vue');
const PollView  = () => import('../views/poll/PollView.vue');
const PollEdit  = () => import('../views/poll/PollEdit.vue');
const PollPrint = () => import('../views/poll/PollPrint.vue');

const meta: MetaData = {
    module: 'poll',
};

let routes: RouteRecordRaw[] = [
    {
        path: '/poll',
        redirect: {name: 'poll-list'},
    },
    {
        name: 'poll-view',
        path: '/poll/view/:id',
        component: PollView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'poll-print',
        path: '/poll/print/:id',
        component: PollPrint,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'poll-add',
        path: '/poll/add/:copyFrom?',
        alias: '/poll/poll/poll-edit',
        component: PollEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyFrom: toInt(route.params.copyFrom),
            };
        },
    },
    {
        name: 'poll-edit',
        path: '/poll/edit/:id',
        alias: '/poll/poll/poll-edit/id/:id',
        component: PollEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'poll-list',
        path: '/poll/list/:range?',
        component: PollList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                range: 'undefined' !== typeof route.params.range ? toInt(route.params.range) : POLL_RANGE_NO_EXPIRED,
            };
        },
    },
    /* compatibility routes */
    {
        path: '/poll/poll/poll-list/range/:range',
        redirect: {name: 'poll-list'},
    },
    {
        path: '/poll/poll/poll-list/id/:id',
        redirect: {name: 'poll-view'},
    },
    {
        path: '/poll/poll/poll-print/id/:id',
        redirect: {name: 'poll-print'},
    },
    {
        path: '/poll/poll/poll-edit',
        redirect: {name: 'poll-add'},
    },
    {
        path: '/poll/poll/poll-edit/id/:id',
        redirect: {name: 'poll-edit'},
    },
    {
        path: '/poll/:wildcard*',
        redirect: {name: 'poll-list'},
    },
];

export default routes;